<template>
  <div>
    <b-form inline>
      <b-button size="sm" @click="showModal" variant="danger">{{$t('sellerSellect.memberSelect')}}</b-button>
      <label class="margin-left">{{dispSelectedMember}}</label>
      <label v-show="isRequiredReceipt === '1'"   class="margin-left mark-red">　＠領収書要　</label>
      <label v-show="carrier === '2'"   class="margin-left mark-red">　　@超速便DHL　　</label>
      <label v-show="carrier === '4'"   class="margin-left mark-blue">　　@超速便FedEx　　</label>
      <label v-show="carrier === '1'"   class="margin-left mark-green">　　@通常便FedEx　　</label>
      <label v-show="carrier === '90'"   class="margin-left mark-yellow">　　@全自動まとめ便　　</label>
      <label v-show="carrier === '99'"   class="margin-left mark-gray">　　@指定なし　　</label>
      <label v-show="lasNumber !== '0'"   class="margin-left mark-red">　{{this.lasNumber}}　</label>
      <label v-show="sellerType === '1'"   class="margin-left mark-yellow2">　PRIME　</label>
      <label v-show="shippingLimitAmount !== 0 && shippingLimitAmount !== 9999" class="margin-left mark-blue">　{{ this.shippingLimitAmount }}　</label>
      
      <label v-show="memo !== ''"   class="margin-left-x5 mark-memo">★Memo★　{{this.memo}}　</label>
    </b-form>
    <b-modal ref="sellerSelectModel" :title="$t('sellerSellect.title')" hide-footer=true>
      <b-row class="component-margin">
        <b-col sm="12">
          <b-input v-model="filter" :placeholder="$t('sellerSellect.message.requireMemberId')"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                  :items="filteredItems" :fields="fields"
                  :current-page="currentPage" :per-page="perPage">
            <template slot="memberName" slot-scope="row">
              {{row.item['lastNameJp']}} {{row.item['firstNameJp']}}
            </template>
            <template slot="select" slot-scope="row">
              <b-button size="sm" @click="selectSeller(row)" variant="danger">{{$t('sellerSellect.select')}}</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="inputInboundNumberModal" title="入庫した商品を会員BOXに入れてください" @ok="inboundNumberOk">
      <b-row class="component-margin">
        <b-col sm="12">
          <label>会員BOXのバーコードを通す</label>
        </b-col>
      </b-row>
      <b-row class="">
        <b-col sm="12">
          <b-input v-model="inputInboundNumber"/>
        </b-col>
      </b-row>
    </b-modal>
    <b-row>
      <b-modal ref="messagePopupSimple" ok-only hide-header>
        <div class="text-center">{{confirmMessageSimple}}</div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import * as api from '@/api';

export default {
  props: {
    selectedMemberFromManage: { default: ''},
    isInvoicePage: { default: false},
    isRequiredReceipt: { default: '0'},
    carrier: { default: ''},
    lasNumber: { default: '0'},
    memo: { default: ''},
    shippingLimitAmount: { default: 9999},
    inboundNumber: { default: ''},
    isInbound: { default: '0'}
  },
  data() {
    return {
      // rowTmp: {},
      items: [],
      fields: [
        { key: 'memberId',       label: this.$i18n.t('sellerSellect.table.memberId'),       class: 'table-label' },
        { key: 'memberName',     label: this.$i18n.t('sellerSellect.table.memberName'),     class: 'table-label' },
        { key: 'amazonShopName', label: this.$i18n.t('sellerSellect.table.amazonShopName'), class: 'table-label' },
        { key: 'select',         label: this.$i18n.t('sellerSellect.table.select'),         class: 'table-cw4'   },
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: '',
      selectedMember: '',
      sellerType: '0',
      inputInboundNumber: '',
      // inboundNumberCheckPass: false,
      confirmMessageSimple: ''
    };
  },
  computed: {
    filteredItems() {
      let filteredItems = this.items.filter(item => {
        const fullName1 = item.lastNameJp + item.firstNameJp;
        const fullName2 = item.lastNameJp + ' ' + item.firstNameJp;
        const fullName3 = item.lastNameJp + '　' + item.firstNameJp;
        return ((this.filter === '' || item.amazonShopName.indexOf(this.filter) !== -1) ||
                (this.filter === '' || item.memberId.indexOf(this.filter) !== -1) ||
                (this.filter === '' || fullName1.indexOf(this.filter) !== -1) ||
                (this.filter === '' || fullName2.indexOf(this.filter) !== -1) ||
                (this.filter === '' || fullName3.indexOf(this.filter) !== -1));
        });
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      return filteredItems;
    },
    dispSelectedMember(){
      if(this.selectedMember !== null && this.selectedMember !== ''){
        return this.selectedMember;
      } else if(this.selectedMemberFromManage !== null && this.selectedMemberFromManage !== ''){
        return this.selectedMemberFromManage;
      }
    },
  },
  created() {
    api.getSellers((items) => {
      this.items = items;
      this.totalRows = this.items.length;
    });
  },
  methods: {
    showModal() {
      if(this.inboundNumber !== ''){
        this.$refs.inputInboundNumberModal.show();
        return;
      }
      this.filter = '';
      this.$refs.sellerSelectModel.show();
    },
    hideModal() {
      this.$refs.sellerSelectModel.hide();
    },
    selectSeller(row) {
      // 入庫画面から選択した場合
      // if(this.isInbound == '1' && !this.inboundNumberCheckPass && row.item.inboundNumber != ''){
      //   this.rowTmp = row;
      //   this.$refs.inputInboundNumberModal.show();
      //   return;
      // }
      // this.inboundNumberCheckPass = false;
      this.selectedMember = '【' + row.item.memberId + '】【' + row.item.amazonShopName + '】' +  row.item.lastNameJp + ' ' + row.item.firstNameJp;
      if(this.isInvoicePage){
        this.selectedMember = '【' + row.item.amazonShopName + '】' +  row.item.lastNameJp + ' ' + row.item.firstNameJp;
      }
      this.sellerType = row.item.sellerType;
      this.$emit('selected', row.item);
      this.hideModal();
    },
    inboundNumberOk(){
      // 入力された入庫番号が正しい場合
      if(this.inboundNumber == this.inputInboundNumber && this.inputInboundNumber.length < 21){
        this.filter = '';
        this.$refs.sellerSelectModel.show();
        this.inputInboundNumber = '';
        // this.selectSeller(this.rowTmp);
        return;
      }
      // 入力文字数が20桁を超える場合
      if(this.inputInboundNumber.length > 20){
        this.confirmMessageSimple = '20桁を超える文字は登録できません。';
        this.$refs.messagePopupSimple.show();
        this.inputInboundNumber = '';
        return;
      }
      // 入庫された入庫番号が間違っている場合
      this.confirmMessageSimple = '番号が一致しません。再度確認してください。';
      this.$refs.messagePopupSimple.show();
      this.inputInboundNumber = '';
    },
  },
};
</script>
<style>
.margin-left {
  margin-left: 1rem;
}
.margin-left-x5 {
  margin-left: 5rem;
}
.component-margin {
  margin-bottom: 1rem;
}
.mark-red {
    background-color: red;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-blue {
    background-color: blue;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-green {
    background-color: green;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-yellow {
    background-color: yellow;
    color: black;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-gray {
    background-color: gray;
    color: white;
    border-radius: 0.5rem;
    font-size: 0.8rem;
}
.mark-yellow2 {
    background-color: yellow;
    color: black;
    border-radius: 0.2rem;
    font-size: 0.8rem;
    border: 1px solid #607D8B;
}
.mark-memo {
    background-color: #ffa50087;
    color: black;
    border-radius: 0.1rem;
    font-size: 1.5rem;
    border: 1px solid #607D8B;
}

@media (min-width: 768px) {
  .table-label div {
    transform: translateY(0.3rem);
  }
  .table-cw4 {
    min-width: 4rem;
    max-width: 4rem;
    width: 4rem;
    text-align:center!important;
  }
}
</style>
